import { render, staticRenderFns } from "./Loader.vue?vue&type=template&id=6370836e"
import script from "./Loader.js?vue&type=script&lang=js&external"
export * from "./Loader.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports